const destroyedSessionKeysStore = new Set<string>();
const reopenedSessionKeysStore = new Set<string>();

const normalizeSessionKey = (value: string): string =>
  (value || "").replace(/^grpcht:/, "").replace(/^conf:/, "");

export const isSameSessionKey = (a: string, b: string): boolean => {
  if (!a || !b) return false;
  return a === b || normalizeSessionKey(a) === normalizeSessionKey(b);
};

export const isSessionKeyReopened = (sessionKey: string): boolean =>
  !!sessionKey && Array.from(reopenedSessionKeysStore).some((key) => isSameSessionKey(key, sessionKey));

export const isSessionKeyDestroyed = (sessionKey: string): boolean =>
  !!sessionKey && Array.from(destroyedSessionKeysStore).some((key) => isSameSessionKey(key, sessionKey));

export { destroyedSessionKeysStore, reopenedSessionKeysStore };
